import React/* , { Component } */ from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
//import RenderFilterRangeDate from '../Complements/RenderFilterRangeDate';
//import moment from 'moment'
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  /* TablePagination, */
  CircularProgress,
  Button,
} from '@material-ui/core';
/* import AttachFileIcon from '@material-ui/icons/AttachFile';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn; */

const ModalTableReportDetails = props => {

  /* render() { */

  const {
    openModal,
    onCloseModal,
    isLoading,

    details
  } = props;
  return (
    <div>
      <Dialog open={openModal} onClose={onCloseModal} aria-labelledby="form-dialog-title" maxWidth="md" fullWidth={true} disableBackdropClick>
        <DialogTitle id="form-dialog-title">Detalles</DialogTitle>
        <DialogContent>
          {isLoading ? (
            <CircularProgress />
          ) : (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: '25%', textAlign: 'center' }}>Fecha</TableCell>
                    <TableCell style={{ width: '25%', textAlign: 'center' }}>Transacción</TableCell>
                    <TableCell style={{ width: '25%', textAlign: 'center' }}>Concepto</TableCell>
                    <TableCell style={{ width: '25%', textAlign: 'center' }}>Tipo</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.keys(details).length > 0 && details?.state !== "Error" ? (
                    <TableRow key={details.identification}>
                      <TableCell style={{ width: '25%', textAlign: 'center' }}>{details.fecha}</TableCell>
                      <TableCell style={{ width: '25%', textAlign: 'center' }}>{details.TypeDesc}</TableCell>
                      <TableCell style={{ width: '25%', textAlign: 'center' }}>{details.Description}</TableCell>
                      <TableCell style={{ width: '25%', textAlign: 'center' }}>{details.tipoMovimiento}</TableCell>
                    </TableRow>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} align={'center'}><b>No se han encontrado registros</b></TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onCloseModal} color="primary" variant="contained">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
  /* } */
};

export default ModalTableReportDetails;